import axios from 'axios'
import pubsub from 'pubsub-js'
import React from 'react'
import { Button, Card, CardBody, CardFooter, Col, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap'
import AsyncSelect from 'react-select/async'
import 'sweetalert2/src/sweetalert2.scss'
import FormValidator from '../../Forms/FormValidator.js'
import ContentWrapper from '../../Layout/ContentWrapper'
import { DeleteDialogBox } from '../../Common/DialogBox'

class EditPermissions extends React.Component {
  constructor() {
    super()
    this.state = {
      isEdit: false,
      formPermission: {
        key: '',
        description: ''
      },
      allowedIds: [],
      allowedIps: [],
      allowedUserLevels: [],
      populatedIds: [],
      newAllowedId: '',
      newAllowedIp: '',
      newAllowedUserLevel: '',
      allowedIdSearchInput: '',
      // Options for selects
      users: [],
      departments: [],
      projects: [],
      functions: [],
      loadingOptions: false,
      isSubmitting: false
    }
    this.pendingInputClearTimer = null
  }

  validateOnChange = (event) => {
    const input = event.target
    const form = input.form
    const value = input.type === 'checkbox' ? input.checked : input.value
    const result = FormValidator.validate(input)
    this.setState({
      [form.name]: {
        ...this.state[form.name],
        [input.name]: value,
        errors: {
          ...this.state[form.name].errors,
          [input.name]: result
        }
      }
    })
  }

  hasError = (formName, inputName, method) => {
    return (
      this.state[formName] &&
      this.state[formName].errors &&
      this.state[formName].errors[inputName] &&
      this.state[formName].errors[inputName][method]
    )
  }

  handleAddAllowedId = async () => {
    const idToAdd = this.state.newAllowedId.trim()
    if (idToAdd && !this.state.allowedIds.includes(idToAdd)) {
      // Try to find the ID in our loaded options
      const allOptions = [...this.state.users, ...this.state.departments, ...this.state.projects, ...this.state.functions]
      const foundOption = allOptions.find((opt) => opt.value === idToAdd)

      const populatedId = foundOption
        ? {
            id: idToAdd,
            type: foundOption.type,
            name: foundOption.label.split(' (')[0] // Remove email from label if present
          }
        : {
            id: idToAdd,
            type: 'unknown',
            name: idToAdd
          }

      this.setState({
        allowedIds: [...this.state.allowedIds, idToAdd],
        populatedIds: [...this.state.populatedIds, populatedId],
        newAllowedId: ''
      })
    }
  }

  handleRemoveAllowedId = (index) => {
    const newIds = [...this.state.allowedIds]
    const newPopulatedIds = [...this.state.populatedIds]
    newIds.splice(index, 1)
    newPopulatedIds.splice(index, 1)
    this.setState({ allowedIds: newIds, populatedIds: newPopulatedIds })
  }

  handleAddAllowedIp = () => {
    if (this.state.newAllowedIp.trim()) {
      this.setState({
        allowedIps: [...this.state.allowedIps, this.state.newAllowedIp.trim()],
        newAllowedIp: ''
      })
    }
  }

  handleRemoveAllowedIp = (index) => {
    const newIps = [...this.state.allowedIps]
    newIps.splice(index, 1)
    this.setState({ allowedIps: newIps })
  }

  handleAddAllowedUserLevel = () => {
    const level = parseInt(this.state.newAllowedUserLevel)
    if (!isNaN(level) && level >= 1 && level <= 8) {
      if (!this.state.allowedUserLevels.includes(level)) {
        this.setState({
          allowedUserLevels: [...this.state.allowedUserLevels, level].sort((a, b) => a - b),
          newAllowedUserLevel: ''
        })
      }
    }
  }

  handleRemoveAllowedUserLevel = (index) => {
    const newLevels = [...this.state.allowedUserLevels]
    newLevels.splice(index, 1)
    this.setState({ allowedUserLevels: newLevels })
  }

  deletePermission = () => {
    const ID = this.props.match.params.idPermission
    if (ID) {
      const goBack = () => this.props.history.push('/permissions')
      const path = `permissions/${ID}`
      const name = 'qasjen'
      DeleteDialogBox({ path, name, goBack })
    }
  }

  onSubmit = (e) => {
    e.preventDefault()

    // Prevent multiple submissions
    if (this.state.isSubmitting) {
      return
    }

    const ID = this.props.match.params.idPermission
    const form = e.target
    const inputs = [...form.elements].filter(
      (i) => ['INPUT', 'SELECT'].includes(i.nodeName) && i.name && i.type !== 'button' && i.type !== 'submit'
    )

    const { errors, hasError } = FormValidator.bulkValidate(inputs)
    this.setState({
      [form.name]: {
        ...this.state[form.name],
        errors
      }
    })

    if (!hasError) {
      this.setState({ isSubmitting: true })

      const postData = {
        key: this.state.formPermission.key,
        description: this.state.formPermission.description,
        allowedIds: this.state.allowedIds,
        allowedIps: this.state.allowedIps,
        allowedUserLevels: this.state.allowedUserLevels
      }

      if (ID) {
        axios
          .put(`permissions/${ID}`, postData)
          .then((res) => {
            if (res.data.success) {
              this.props.history.push('/permissions')
              pubsub.publish('showNotification', {
                message: 'Të dhënat janë ndryshuar!',
                type: 'success'
              })
            } else {
              this.setState({ isSubmitting: false })
              pubsub.publish('showNotification', {
                message: res.data.message || 'Gabim gjatë ndryshimit të të dhënave',
                type: 'error'
              })
            }
          })
          .catch((err) => {
            this.setState({ isSubmitting: false })
            pubsub.publish('showNotification', {
              message: err.response?.data?.message || 'Gabim gjatë ndryshimit të të dhënave',
              type: 'error'
            })
          })
      } else {
        axios
          .post('permissions', postData)
          .then((res) => {
            if (res.data.success) {
              pubsub.publish('showNotification', {
                message: 'Të dhënat janë ruajtur!',
                type: 'success'
              })
              this.props.history.push('/permissions')
            } else {
              this.setState({ isSubmitting: false })
              pubsub.publish('showNotification', {
                message: res.data.message || 'Gabim gjatë ruajtjes të të dhënave',
                type: 'error'
              })
            }
          })
          .catch((err) => {
            this.setState({ isSubmitting: false })
            pubsub.publish('showNotification', {
              message: err.response?.data?.message || 'Gabim gjatë ruajtjes të të dhënave',
              type: 'error'
            })
          })
      }
    }
  }

  async componentDidMount() {
    const idPermission = this.props.match.params.idPermission

    // Load options for selects
    await this.loadSelectOptions()

    if (idPermission) {
      try {
        const res = await axios.get(`permissions/${idPermission}`)
        const data = res.data.data
        await this.setState({
          isEdit: true,
          formPermission: {
            key: data.key || '',
            description: data.description || ''
          },
          allowedIds: data.allowedIds || [],
          allowedIps: data.allowedIps || [],
          allowedUserLevels: data.allowedUserLevels || [],
          populatedIds: data.populatedIds || []
        })
      } catch (error) {
        console.error('Error fetching permission:', error)
      }
    }
  }

  loadSelectOptions = async () => {
    try {
      this.setState({ loadingOptions: true })
      const [departmentsRes, projectsRes, functionsRes] = await Promise.all([
        axios.get('departments'),
        axios.get('projects'),
        axios.get('roles')
      ])

      const departments = departmentsRes.data.success
        ? departmentsRes.data.data.map((dept) => ({
            value: dept._id,
            label: dept.name,
            type: 'department'
          }))
        : []

      const projects = projectsRes.data.success
        ? projectsRes.data.data.map((project) => ({
            value: project._id,
            label: project.name,
            type: 'project'
          }))
        : []

      const functions = functionsRes.data.success
        ? functionsRes.data.data.map((func) => ({
            value: func._id,
            label: func.name,
            type: 'function'
          }))
        : []

      this.setState({
        departments,
        projects,
        functions,
        loadingOptions: false
      })
    } catch (error) {
      console.error('Error loading select options:', error)
      this.setState({ loadingOptions: false })
    }
  }

  loadAllowedIdOptions = (() => {
    let debounceTimer = null
    const DEBOUNCE_MS = 400

    return (inputValue) => {
      return new Promise((resolve) => {
        if (debounceTimer) clearTimeout(debounceTimer)
        debounceTimer = setTimeout(async () => {
          debounceTimer = null
          const search = (inputValue || '').trim()
          const { departments, projects, functions } = this.state

          const filterByInput = (options, searchStr) => {
            if (!searchStr) return options
            const lower = searchStr.toLowerCase()
            return options.filter((opt) => opt.label.toLowerCase().includes(lower))
          }

          const filteredDepts = filterByInput(departments, search)
          const filteredProjects = filterByInput(projects, search)
          const filteredFunctions = filterByInput(functions, search)

          let users = []
          try {
            const usersRes = await axios.get(`users/activeandinactive?page=1&limit=30&search=${encodeURIComponent(search)}`)
            const usersData = usersRes.data.success ? usersRes.data.data.docs || usersRes.data.data || [] : []
            users = usersData.map((user) => ({
              value: user._id,
              label: `${user.first_name} ${user.last_name} (${user.email})`,
              type: 'user'
            }))
          } catch (err) {
            console.error('Error loading users:', err)
          }

          const groups = []
          if (users.length > 0) groups.push({ label: 'Përdoruesit', options: users })
          if (filteredDepts.length > 0) groups.push({ label: 'Departamentet', options: filteredDepts })
          if (filteredProjects.length > 0) groups.push({ label: 'Projektet', options: filteredProjects })
          if (filteredFunctions.length > 0) groups.push({ label: 'Funksionet', options: filteredFunctions })

          resolve(groups)
        }, DEBOUNCE_MS)
      })
    }
  })()

  handleAddAllowedIdFromSelect = (selectedOption) => {
    if (this.pendingInputClearTimer) {
      clearTimeout(this.pendingInputClearTimer)
      this.pendingInputClearTimer = null
    }
    if (selectedOption && !this.state.allowedIds.includes(selectedOption.value)) {
      this.setState({
        allowedIds: [...this.state.allowedIds, selectedOption.value],
        populatedIds: [
          ...this.state.populatedIds,
          {
            id: selectedOption.value,
            type: selectedOption.type,
            name: selectedOption.label.split(' (')[0] // Remove email from label
          }
        ]
      })
    }
  }

  handleAllowedIdInputChange = (newValue, actionMeta = {}) => {
    const { action } = actionMeta
    if (this.pendingInputClearTimer) {
      clearTimeout(this.pendingInputClearTimer)
      this.pendingInputClearTimer = null
    }
    if (newValue === '') {
      if (['set-value', 'menu-close', 'input-blur'].includes(action)) {
        return
      }
      this.pendingInputClearTimer = setTimeout(() => {
        this.pendingInputClearTimer = null
        this.setState({ allowedIdSearchInput: '' })
      }, 150)
    } else {
      this.setState({ allowedIdSearchInput: newValue || '' })
    }
  }

  render() {
    const id = this.props.match.params.idPermission
    return (
      <ContentWrapper>
        {this.state.isEdit ? (
          <div className='d-flex justify-content-between'>
            <p style={{ fontSize: 23, color: 'gray' }}>Modifiko qasjen</p>
            <div>
              <Button onClick={() => this.props.history.goBack()} color='info' className='btn-labeled'>
                <span className='btn-label'>
                  <i className='fa fa-arrow-left' />
                </span>{' '}
                Prapa
              </Button>
            </div>
          </div>
        ) : (
          <div className='d-flex justify-content-between'>
            <p style={{ fontSize: 23, color: 'gray' }}>Shto qasje të re</p>
            <div>
              <Button onClick={() => this.props.history.goBack()} color='info' className='btn-labeled'>
                <span className='btn-label'>
                  <i className='fa fa-arrow-left' />
                </span>{' '}
                Prapa
              </Button>
            </div>
          </div>
        )}
        <Row>
          <div className='col-md-12'>
            <form onSubmit={this.onSubmit} name='formPermission'>
              <Card className='card-default'>
                <CardBody>
                  <legend className='mb-4' />
                  <fieldset>
                    <div className='form-group row align-items-center'>
                      <label className='col-md-2 col-form-label'>Key:</label>
                      <Col md={8}>
                        <Input
                          key='key'
                          type='text'
                          name='key'
                          invalid={this.hasError('formPermission', 'key', 'required')}
                          onChange={this.validateOnChange}
                          value={this.state.formPermission.key}
                          data-validate='["required"]'
                          placeholder='e.g., allowed_to_check_timetrackings'
                        />
                        <span className='invalid-feedback'>Fusha është e nevojshme</span>
                      </Col>
                    </div>
                  </fieldset>
                  <fieldset>
                    <div className='form-group row align-items-center'>
                      <label className='col-md-2 col-form-label'>Përshkrimi:</label>
                      <Col md={8}>
                        <Input
                          key='description'
                          type='textarea'
                          name='description'
                          invalid={this.hasError('formPermission', 'description', 'required')}
                          onChange={this.validateOnChange}
                          value={this.state.formPermission.description}
                          data-validate='["required"]'
                          rows={3}
                          placeholder='Përshkrimi i qasjes'
                        />
                        <span className='invalid-feedback'>Fusha është e nevojshme</span>
                      </Col>
                    </div>
                  </fieldset>

                  {/* Allowed IDs */}
                  <fieldset>
                    <div className='form-group row align-items-center'>
                      <label className='col-md-2 col-form-label'>Allowed IDs:</label>
                      <Col md={8}>
                        <div className='mb-2' style={{ position: 'relative', zIndex: 1000 }}>
                          <AsyncSelect
                            placeholder='Zgjidhni Përdorues, Departament, Projekt, ose Funksion'
                            loadOptions={this.loadAllowedIdOptions}
                            defaultOptions={true}
                            cacheOptions
                            isLoading={this.state.loadingOptions}
                            onChange={this.handleAddAllowedIdFromSelect}
                            value={null}
                            inputValue={this.state.allowedIdSearchInput}
                            onInputChange={this.handleAllowedIdInputChange}
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              menu: (base) => ({ ...base, zIndex: 9999 })
                            }}
                          />
                        </div>
                        <InputGroup className='mt-2' style={{ position: 'relative', zIndex: 1 }}>
                          <Input
                            type='text'
                            value={this.state.newAllowedId}
                            onChange={(e) => this.setState({ newAllowedId: e.target.value })}
                            placeholder='Ose shkruani ID manualisht'
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault()
                                this.handleAddAllowedId()
                              }
                            }}
                          />
                          <InputGroupAddon addonType='append'>
                            <Button type='button' color='success' onClick={this.handleAddAllowedId}>
                              Shto ID
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                        <small className='form-text text-muted'>Lëreni bosh për qasje të gjithëve. Shtoni ID për të kufizuar qasjen.</small>
                        {this.state.allowedIds.length > 0 && (
                          <div className='mt-2'>
                            {this.state.allowedIds.map((id, index) => {
                              const populated = this.state.populatedIds[index]
                              const typeToBadgeColor = {
                                user: 'primary',
                                department: 'success',
                                project: 'info',
                                function: 'warning'
                              }
                              const typeToIcon = {
                                user: '👤',
                                department: '🏢',
                                project: '📁',
                                function: '⚙️'
                              }
                              const badgeColor = typeToBadgeColor[populated?.type] ?? 'secondary'
                              const icon = typeToIcon[populated?.type] ?? '❓'
                              return (
                                <span key={index} className={`badge badge-${badgeColor} mr-2 mb-2`} style={{ fontSize: '14px' }}>
                                  {icon} {populated?.name || id}
                                  <button
                                    type='button'
                                    className='ml-2'
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      color: 'white',
                                      cursor: 'pointer',
                                      fontSize: '16px'
                                    }}
                                    onClick={() => this.handleRemoveAllowedId(index)}
                                  >
                                    ×
                                  </button>
                                </span>
                              )
                            })}
                          </div>
                        )}
                      </Col>
                    </div>
                  </fieldset>

                  {/* Allowed IPs */}
                  <fieldset>
                    <div className='form-group row align-items-center'>
                      <label className='col-md-2 col-form-label'>Allowed IPs:</label>
                      <Col md={8}>
                        <InputGroup>
                          <Input
                            type='text'
                            value={this.state.newAllowedIp}
                            onChange={(e) => this.setState({ newAllowedIp: e.target.value })}
                            placeholder='Shto IP adresë (e.g., 192.168.1.1)'
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault()
                                this.handleAddAllowedIp()
                              }
                            }}
                          />
                          <InputGroupAddon addonType='append'>
                            <Button type='button' color='success' onClick={this.handleAddAllowedIp}>
                              Shto
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                        <small className='form-text text-muted'>
                          Lëreni bosh për qasje të gjithë IP-ve. Shtoni IP për të kufizuar qasjen.
                        </small>
                        {this.state.allowedIps.length > 0 && (
                          <div className='mt-2'>
                            {this.state.allowedIps.map((ip, index) => (
                              <span key={index} className='badge badge-info mr-2 mb-2' style={{ fontSize: '14px' }}>
                                {ip}
                                <button
                                  type='button'
                                  className='ml-2'
                                  style={{
                                    background: 'none',
                                    border: 'none',
                                    color: 'white',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                  }}
                                  onClick={() => this.handleRemoveAllowedIp(index)}
                                >
                                  ×
                                </button>
                              </span>
                            ))}
                          </div>
                        )}
                      </Col>
                    </div>
                  </fieldset>

                  {/* Allowed User Levels */}
                  <fieldset>
                    <div className='form-group row align-items-center'>
                      <label className='col-md-2 col-form-label'>Allowed User Levels:</label>
                      <Col md={8}>
                        <InputGroup>
                          <Input
                            type='number'
                            min='1'
                            max='8'
                            value={this.state.newAllowedUserLevel}
                            onChange={(e) => this.setState({ newAllowedUserLevel: e.target.value })}
                            placeholder='Niveli i përdoruesit (1-8)'
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault()
                                this.handleAddAllowedUserLevel()
                              }
                            }}
                          />
                          <InputGroupAddon addonType='append'>
                            <Button type='button' color='success' onClick={this.handleAddAllowedUserLevel}>
                              Shto
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                        <small className='form-text text-muted'>
                          Lëreni bosh për qasje të gjithë niveleve. Shtoni nivele për të kufizuar qasjen (1-8).
                        </small>
                        {this.state.allowedUserLevels.length > 0 && (
                          <div className='mt-2'>
                            {this.state.allowedUserLevels.map((level, index) => (
                              <span key={index} className='badge badge-warning mr-2 mb-2' style={{ fontSize: '14px' }}>
                                Niveli {level}
                                <button
                                  type='button'
                                  className='ml-2'
                                  style={{
                                    background: 'none',
                                    border: 'none',
                                    color: 'white',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                  }}
                                  onClick={() => this.handleRemoveAllowedUserLevel(index)}
                                >
                                  ×
                                </button>
                              </span>
                            ))}
                          </div>
                        )}
                      </Col>
                    </div>
                  </fieldset>
                </CardBody>
                <CardFooter>
                  <Button type='submit' color='success' className='mr-2' disabled={this.state.isSubmitting}>
                    {this.state.isSubmitting ? 'Duke ruajtur...' : this.state.isEdit ? 'Ruaj ndryshimet' : 'Ruaj'}
                  </Button>
                  {this.state.isEdit && (
                    <Button
                      type='button'
                      color='danger'
                      className='mr-2'
                      onClick={this.deletePermission}
                      disabled={this.state.isSubmitting}
                    >
                      Fshije
                    </Button>
                  )}
                  <Button type='button' color='secondary' onClick={() => this.props.history.goBack()} disabled={this.state.isSubmitting}>
                    Anulo
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </div>
        </Row>
      </ContentWrapper>
    )
  }
}

export default EditPermissions
